<template>
  <div>
    <div class="row px-3" v-if="permissions['development_proposals'] > 1">
      <div class="col-12">
        <button
            v-if="this.countUserProposals() < this.limit_max"
            type="button"
            class="btn btn--green ml-2"
            data-toggle="modal"
            :data-target="'#addProposalModal' + this.question_survey_id"
        > {{ __("views.EvaluationChart.addProposal") }}
        </button>
        <p class="text-voice-title" v-else>
          <i class="fa-solid fa-circle-exclamation colored-icon"></i>
          {{ __("views.EvaluationChart.reachedLimit") }}
        </p>
      </div>
    </div>

    <div class="row px-3 mt-4">
      <div class="col-12">
        <table class="table table-custom-header">
          <thead>
            <tr>
              <th class="one-action-col">
                {{ __("misc.actions") }}
              </th>
              <th>
                {{ __("views.EvaluationChart.devProposal") }}
              </th>
              <th>
                {{ __("views.EvaluationChart.devProposalDetails") }}
              </th>
            </tr>
          </thead>
          <tbody>
          <tr v-for="(proposal, index) in userProposals" :key="index">
            <td class="one-action-col">
              <div
                  style="cursor: pointer"
                  class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-remove mx-1"
                  v-if="permissions['development_proposals'] > 1"
              >
                <i class="fas fa-trash" @click="deleteProposal(index)"></i>
              </div>
            </td>
            <td>
              <p>{{ proposal.proposal }}</p>
            </td>
            <td>
              <div
                  v-for="(chunk_element, index_chunk) in columns_permissions"
                  :key="index_chunk"
                  class="row"
              >
                <div
                    class="col-6"
                    v-for="(element, index_elem) in chunk_element"
                    :key="index_elem"
                >
                  <label>{{ element.label[locale] }}</label>
                  <div
                      v-if="
                        element.type == 'comment' &&
                        permissions[element.key] == 1
                      "
                      class=""
                  >
                    {{ proposal[element.key] }}
                  </div>
                  <input
                      v-if="
                        element.type == 'date' && permissions[element.key] == 1
                      "
                      type="date"
                      class="form-control"
                      v-model="proposal[element.key]"
                      disabled
                  />
                  <input
                      type="hidden"
                      :name="'question['+question_survey_id+'][developments_proposals]['+index+'][proposal]'"
                      :value="proposal.proposal"
                  >
                  <textarea
                      v-if="
                        element.type == 'comment' &&
                        permissions[element.key] == 2
                      "
                      class="form-control"
                      style="height: calc(1.5em + 0.75rem + 2px)"
                      :name="'question['+question_survey_id+'][developments_proposals]['+index+']['+ element.key +']'"
                      v-model="proposal[element.key]"
                  ></textarea>
                  <textarea
                      v-if="
                        element.type == 'comment' &&
                        permissions[element.key] == 3
                      "
                      class="form-control requiredQuestion"
                      style="height: calc(1.5em + 0.75rem + 2px)"
                      :name="'question['+question_survey_id+'][developments_proposals]['+index+']['+ element.key +']'"
                      v-model="proposal[element.key]"
                  ></textarea>
                  <input
                      v-if="
                        element.type == 'date' && permissions[element.key] == 2
                      "
                      type="date"
                      class="form-control"
                      style="height: calc(1.5em + 0.75rem + 2px)"
                      v-model="proposal[element.key]"
                      :name="'question['+question_survey_id+'][developments_proposals]['+index+']['+ element.key +']'"
                  />
                  <input
                      v-if="
                        element.type == 'date' && permissions[element.key] == 3
                      "
                      type="date"
                      class="form-control requiredQuestion"
                      style="height: calc(1.5em + 0.75rem + 2px)"
                      v-model="proposal[element.key]"
                      :name="'question['+question_survey_id+'][developments_proposals]['+index+']['+ element.key +']'"
                  />
                  <select
                      v-if="
                        element.type == 'options' &&
                        permissions[element.key] == 1
                      "
                      class="form-control"
                      v-model="proposal[element.key]"
                      disabled
                  >
                    <option value="">---</option>
                    <option
                        v-for="(option, option_index) in element.options"
                        :value="option_index"
                        :key="option_index"
                    >
                      {{ option[locale] }}
                    </option>
                  </select>
                  <select
                      v-if="
                        element.type == 'options' &&
                        permissions[element.key] == 2
                      "
                      class="form-control"
                      style="height: calc(1.5em + 0.75rem + 2px)"
                      v-model="proposal[element.key]"
                      :name="'question['+question_survey_id+'][developments_proposals]['+index+']['+ element.key +']'"
                  >
                    <option value="">---</option>
                    <option
                        v-for="(option, index_opt) in element.options"
                        :value="index_opt"
                        :key="index_opt"
                    >
                      {{ option[locale] }}
                    </option>
                  </select>
                  <select

                      v-if="
                        element.type == 'options' &&
                        permissions[element.key] == 3
                      "
                      class="form-control requiredQuestion"
                      style="height: calc(1.5em + 0.75rem + 2px)"
                      v-model="proposal[element.key]"
                      :name="'question['+question_survey_id+'][developments_proposals]['+index+']['+ element.key +']'"
                  >
                    <option value="">---</option>
                    <option
                        v-for="(option, index_opt) in element.options"
                        :value="index_opt"
                        :key="index_opt"
                    >
                      {{ option[locale] }}
                    </option>
                  </select>
                </div>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- modals -->
    <div
        class="modal fade"
        :id="'addProposalModal' + this.question_survey_id"
        tabindex="-1"
        role="dialog"
        aria-labelledby="addProposalModalLabel"
        aria-hidden="true"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content" style="border-radius: 1.5rem">
          <div class="modal-header">
            <h5 class="modal-title" id="addProposalModalLabel">
              {{ __("views.EvaluationChart.addProposal") }}
            </h5>
            <button
                type="button"
                ref="addProposalCloseModal"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row py-5">
              <div
                  :class="modalFieldClass"
                  v-for="(proposal, question) in questions"
                  :key="question"
              >

                <label>{{ question }}</label>
                <select v-if="(pnp_question_indicator_filter !== null) && (pnp_question_indicator_filter.question == proposal.question_survey_id && pnp_question_indicator_filter.filter == 'Indicatori') && !Array.isArray(proposal.values)" class="form-control" v-model="newProposal">
                  {{ proposal }}
                  <optgroup v-for="(group, index) in proposal.values" :value="group" :key="index" :label="index">
                    {{ index }}
                    <option v-for="(element,i) in group" :value="element" :key="i">
                      {{ element }}
                    </option>
                  </optgroup>
                </select>
                <select v-else class="form-control" v-model="newProposal">
                  <option value=""></option>
                  <option v-for="label in proposal.values" :value="label" :key="label">
                    {{ label }}
                  </option>
                </select>
              </div>
              <div v-if="free_requests" :class="modalFieldClass">
                <label
                >{{ __("views.EvaluationChart.free_development_proposals") }}
                </label>
                <textarea
                    name=""
                    id=""
                    cols="30"
                    rows="10"
                    class="form-control"
                    v-model="freeTxtRequest"
                ></textarea>
              </div>
            </div>
            <div class="col-12 text-right">
              <button
                  class="btn btn--green"
                  type="button"
                  @click="sendProposal()"
              >{{ __("views.EvaluationChart.addProposal") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.getChartProposals();
  },
  props: {
    limit_min: {
      type: Number,
      required: false,
    },
    limit_max: {
      type: Number,
      required: false,
    },
    evaluation_chart_id: {
      type: Number,
      required: true,
    },
    question_survey_id: {
      type: Number,
      required: true,
    },
    permissions: {
      type: Object,
      required: true,
    },
    is_admin: {
      type: Boolean,
      required: true,
    },
    free_requests: {
      type: Boolean,
      required: true,
    },
    questions: {
      type: Object,
      required: true,
    },
    columns_permissions: {
      type: Array,
      required: true,
    },
    locale: {
      type: String,
      required: true,
    },
    empty_values: {
      type: Boolean,
      required: false,
      default: false,
    },
    alert_label_insert_one_proposal: {
      type: String,
      required: true,
    },
    alert_label_required: {
      type: String,
      required: true,
    },
    pnp_question_indicator_filter: {
      type: Object,
      required: false,
      default :null,
    },
  },
  data() {
    return {
      userProposals: [],
      newProposal: null,
      freeTxtRequest: null,
      //default
      action: "",
      editing: true,
      csrf: document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute("content"),
    };
  },
  computed: {
    modalFieldClass() {
      const fields = Object.keys(this.questions || {}).length + (this.free_requests ? 1 : 0);

      return fields > 1 ? "col-12 col-md-6" : "col-12";
    },
  },
  methods: {
    updateProposal(event, index, element) {
      return;
      axios
          .put(
              "/update-development-proposals-chart/" +
              this.evaluation_chart_id +
              "/" +
              this.question_survey_id,
              {
                index: index,
                element: element,
                value: event.target.value,
              }
          )
          .then((response) => {
            this.getChartProposals();
          });
    },

    deleteProposal(index) {
      axios
          .delete(
              "/delete-development-proposals-chart/" +
              this.evaluation_chart_id +
              "/" +
              this.question_survey_id,
              {
                params: { index: index },
              }
          )
          .then((response) => {
            this.getChartProposals();
          });
    },

    sendNewSelectProposal(event) {
      this.storeNewProposal(event.target.value);
    },

    sendNewFreeProposal(txt) {
      this.storeNewProposal(this.freeTxtRequest);
      this.freeTxtRequest = null;
      this.$refs.addProposalCloseModal.click();
    },
    sendProposal() {
      let divId = "addProposalModal" + this.question_survey_id;
      let valueSelect = null;
      if ($("#" + divId + " select option:selected") != null) {
        if ($("#" + divId + " select option:selected")[0] != null) {
          valueSelect = $("#" + divId + " select option:selected")[0].value;
        }
      }
      
      if (          
          this.freeTxtRequest != null &&
          this.freeTxtRequest != "" &&
          valueSelect != null &&
          valueSelect != "null" &&
          valueSelect != ""
      ) {
        Vue.swal.fire({ title: this.alert_label_insert_one_proposal });
        return;
      }

      let value = null;
      if (valueSelect != "null" && valueSelect != null && valueSelect != "") {
        value = valueSelect;
      } else {
        value = this.freeTxtRequest;
      }

      if (value == null || value == "null" || value == "") {
        Vue.swal.fire({ title: this.alert_label_required });
        return;
      }

      this.storeNewProposal(value);
      this.freeTxtRequest = null;
      this.$refs.addProposalCloseModal.click();
    },
    storeNewProposal(value) {
      axios
          .post(
              "/store-development-proposals-chart/" +
              this.evaluation_chart_id +
              "/" +
              this.question_survey_id,
              {
                proposal: value,
              }
          )
          .then((response) => {
            this.newProposal = null;
            if (response.data == -1) {
              Vue.swal.fire({
                title: "Proposta di sviluppo già inserita",
              });
              return;
            }
            this.getChartProposals();
          });
    },

    getChartProposals() {
      axios
          .get(
              "/development-proposals-chart-user/" +
              this.evaluation_chart_id +
              "/" +
              this.question_survey_id
          )
          .then((response) => {
            this.userProposals = response.data;
          });
    },
    countUserProposals() {
      if(this.userProposals !== undefined && this.userProposals != null){
        return Object.values(this.userProposals).length;
      } else {
        return 0;
      }
    }
  },
};
</script>

<style scoped>

.table-custom-header {
  width: 100%;
  table-layout: fixed;
}

.table-custom-header thead tr th {
  background: transparent;
  color: #1767A2 !important;
  font-weight: 800 !important;
}
.table-custom-header thead tr th a {
  color: white;
}

.table-custom-header .one-action-col {
  width: 80px;
}

.table-custom-header th:nth-child(2),
.table-custom-header td:nth-child(2) {
  width: 35%;
  word-break: break-word;
}

.table-custom-header th:nth-child(3),
.table-custom-header td:nth-child(3) {
  width: auto;
}

.table-custom-header td > .row {
  width: 100%;
  margin-left: 0;
  margin-right: 0;
  align-items: flex-start;
}

.table-custom-header td .col-6 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.table-custom-header td .col-6:has(select) {
  flex: 0 0 auto;
  max-width: 100%;
  width: auto;
}

.table-custom-header td .col-6:has(textarea) {
  flex: 1 1 0;
  max-width: 100%;
  min-width: 0;
}

.table-custom-header td select {
  width: auto !important;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
}

.table-custom-header td textarea,
.table-custom-header td input:not([type="hidden"]) {
  width: 100% !important;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  display: block;
}
</style>